import React, {Fragment} from "react";
import {loadComponent, saveComponent} from "../../utils/components";
import Box from "../layout/Box";
import parser from 'cron-parser';
import moment from "moment";
import ContentLoader from "../layout/ContentLoader";
import classNames from "classnames";
import Confirm from "../form/Confirm";

const percentColors = [
    {pct: 0.0, color: {r: 216, g: 218, b: 255}},
    {pct: 0.5, color: {r: 245, g: 221, b: 187}},
    {pct: 1.0, color: {r: 255, g: 160, b: 160}}];

const getColorForPercentage = function (pct) {
    let i = 1;
    for (; i < percentColors.length - 1; i++) {
        if (pct < percentColors[i].pct) {
            break;
        }
    }
    let lower = percentColors[i - 1];
    let upper = percentColors[i];
    let range = upper.pct - lower.pct;
    let rangePct = (pct - lower.pct) / range;
    let pctLower = 1 - rangePct;
    let pctUpper = rangePct;
    let color = {
        r: Math.floor(lower.color.r * pctLower + upper.color.r * pctUpper),
        g: Math.floor(lower.color.g * pctLower + upper.color.g * pctUpper),
        b: Math.floor(lower.color.b * pctLower + upper.color.b * pctUpper)
    };
    return 'rgb(' + [color.r, color.g, color.b].join(',') + ')';
    // or output as hex if preferred
}

export class ScheduledTaskStatus extends React.Component {

    state = {
        tasks: null
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.tasks !== prevProps.tasks) {
            this.loadStatus();
        }
    }

    componentDidMount() {
        this.loadStatus();
        this.loadStatusInterval = setInterval(() => {
            this.loadStatus();
        }, 1000 * 60);
    }

    componentWillUnmount() {
        clearInterval(this.loadStatusInterval);
    }

    loadStatus = () => {
        this.loadTasks && this.loadTasks.abort();
        let filter = null;
        if (this.props.tasks) {
            filter = [
                {
                    field: "id",
                    value: this.props.tasks,
                    operator: "in"
                },
            ];
        }
        this.loadTasks = loadComponent("componentlist", {
            component: "ScheduledTask",
            itemsperpage: 0,
            filter
        });
        this.loadTasks.then((list) => {
            this.setState({tasks: list.items});
        });
    }

    render() {
        if (!(this.state.tasks || []).length) {
            return null;
        }
        return (
            <Box
               header={<Fragment>{this.props.header || "Task állapotok"}</Fragment>}
            >
                {this.state.tasks === null ? <ContentLoader /> : this.state.tasks.map((task, idx) => {
                    return <div key={idx} className="row">
                        <div className="col-md-4">
                            {task.name}
                        </div>
                        <div className="col-md-4">
                            Utolsó futtatás ideje: {task.last}
                        </div>
                        <div className="col-md-3">
                            {task.in_progress > 0 ?
                                <span className={classNames("label", {
                                    "label-default": task.ran_ago < 1,
                                    "label-danger": task.ran_ago > 0
                                })}>
                                    {task.ran_ago < 1 ? "Folyamatban" : "Hiba!"}
                                </span> : <span className="label label-default">
                                    Áll
                                </span>
                            }
                        </div>
                        <div className="col-md-1">
                            {!this.props.tasks && task.ran_ago > 0 && task.in_progress > 0 ? <Fragment>
                                {task.ran_ago} alkalommal ezelőtt futott<Fragment>&nbsp;</Fragment>
                                <Confirm
                                    header="Biztos újraindítod?"
                                    body="Biztos újraindítod?"
                                    color="danger"
                                    size="small"
                                    buttonSize="xs"
                                    onAccept={async () => {
                                        await saveComponent("ScheduledTask", {
                                            id: task.id,
                                            in_progress: 0
                                        });
                                        await this.loadStatus();
                                    }}
                                >
                                    Restart
                                </Confirm>
                            </Fragment> : null}
                        </div>
                    </div>
                })}
            </Box>
        );
    }
}

class ScheduledTaskEditor extends React.Component {
    render() {
        return (
            <ScheduledTaskStatus />
        );
    }
}

export default ScheduledTaskEditor;